import { useState } from "react";
import { site } from "@/data/content";

export default function OfficeMaps() {
  const [active, setActive] = useState(0);
  return (
    <div data-testid="contact-map-tabs">
      <div className="flex border-b border-navy/10" role="tablist" aria-label="Office maps">
        {site.offices.map((o, i) => (
          <button
            key={o.city}
            type="button"
            role="tab"
            aria-selected={active === i}
            onClick={() => setActive(i)}
            data-testid={`map-tab-${o.city.toLowerCase()}`}
            className={`relative px-1 pb-4 pr-8 text-[11px] font-semibold uppercase tracking-[0.25em] transition-colors duration-300 ${active === i ? "text-navy" : "text-charcoal-soft hover:text-navy"}`}
          >
            {o.city}
            <span className={`absolute -bottom-px left-0 h-px bg-gold transition-all duration-500 ${active === i ? "w-[calc(100%-2rem)]" : "w-0"}`} />
          </button>
        ))}
      </div>
      <div className="relative mt-6 aspect-square overflow-hidden grayscale-[60%]">
        {site.offices.map((o, i) => (
          <iframe
            key={o.city}
            title={`Immistop office location, ${o.city}`}
            src={o.map}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            data-testid={`contact-map-${o.city.toLowerCase()}`}
            className={`absolute inset-0 h-full w-full transition-opacity duration-700 ${active === i ? "opacity-100" : "pointer-events-none opacity-0"}`}
            aria-hidden={active !== i}
          />
        ))}
      </div>
    </div>
  );
}
